export default __webpack_public_path__ + "static/media/site-atributes.69c496b1.png";